import { render, staticRenderFns } from "./Modalsignup.vue?vue&type=template&id=6ace2008&scoped=true&"
import script from "./Modalsignup.vue?vue&type=script&lang=js&"
export * from "./Modalsignup.vue?vue&type=script&lang=js&"
import style0 from "./Modalsignup.vue?vue&type=style&index=0&id=6ace2008&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ace2008",
  null
  
)

export default component.exports